import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { RmZonesDto } from './rm-zones-dto';

export class RmZonesResponseModel extends GlobalResponseObject{
    data?: RmZonesDto;
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: RmZonesDto){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}
